export default {
  pickerOptions: {
    shortcuts: [
      {
        text: '近三天',
        onClick(picker) {
          const end = new Date(new Date().setHours(23, 59, 59));
          const start = new Date(new Date().setHours(0, 0, 0, 0));
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: '最近一周',
        onClick(picker) {
          const end = new Date(new Date().setHours(23, 59, 59));
          const start = new Date(new Date().setHours(0, 0, 0, 0));
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: '最近一个月',
        onClick(picker) {
          const end = new Date(new Date().setHours(23, 59, 59));
          const start = new Date(new Date().setHours(0, 0, 0, 0));
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: '最近三个月',
        onClick(picker) {
            const end = new Date(new Date().setHours(23, 59, 59));
            const start = new Date(new Date().setHours(0, 0, 0, 0));
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
          picker.$emit('pick', [start, end]);
        }
      }
    ]
  }, 
  statusOptionsArr: [
    {
      value: 1,
      label: '启用'
    },
    {
      value: 0,
      label: '禁用'
    }
  ],
  // 高职单招年份数据 + 不限的 数据
  yearAllOptions: [
    {
      value: "",
      label: "不限"
    },
    {
      value: "2028",
      label: "2028"
    },
    {
      value: "2027",
      label: "2027"
    },
    {
      value: "2026",
      label: "2026"
    },
    {
      value: "2025",
      label: "2025"
    },
    {
      value: "2024",
      label: "2024"
    },
    {
      value: "2023",
      label: "2023"
    },
    {
      value: "2022",
      label: "2022"
    }
  ],

  
}